module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-piso-be0ab291d7ffbe05e2ba9a6b8e426632.jpg";